import { ThemedBenificiaryRemitterDetails as BenificiaryRemitterDetails } from './detail';
export const ThemedBenificiaryRemitterDetails = BenificiaryRemitterDetails;
  